import { DEPENDENCIES_FLYOUT_TYPE } from '@atlassian/jira-software-roadmap-timeline-table-kit/src/common/constants/overlay.tsx';
import type { DependencyTooltip, DependencyTooltipParams } from '../../common/types.tsx';

export const getDependenciesTooltipParams = ({
	tooltip,
}: {
	tooltip: DependencyTooltip;
}): DependencyTooltipParams | undefined => {
	if (tooltip && tooltip.type === DEPENDENCIES_FLYOUT_TYPE) {
		const {
			id,
			position,
			links: { fromIds, toIds },
		} = tooltip;

		return {
			position,
			issueId: id,
			dependencies: fromIds,
			dependees: toIds,
		};
	}

	return undefined;
};
